import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPycharm,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
} from "react-icons/si";
import { FaAws } from "react-icons/fa";

function Toolstack() {
  const iconStyle = {
    fontSize: "4rem",
    color: "#c084f5", // Purple color to match your theme
    padding: "10px",
    transition: "all 0.3s ease",
    cursor: "pointer"
  };

  const hoverStyle = {
    transform: "scale(1.1)",
    color: "#a855f7" // Slightly different purple on hover
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiPycharm 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMacos 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaAws 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
    </Row>
  );
}

export default Toolstack;